var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import calculateFinalResult from './calculateFinalResult';
function createRoll(tokenize, rollDice, tallyRolls, rollConfig) {
    function roll(notation, configOverrides) {
        var finalOverrides = __assign(__assign({}, rollConfig), configOverrides);
        var tokens = tokenize(notation, finalOverrides);
        var rolls = rollDice(tokens, finalOverrides);
        var rollTotals = tallyRolls(tokens, rolls, finalOverrides);
        var result = calculateFinalResult(tokens, rollTotals);
        return {
            tokens: tokens,
            rolls: rolls,
            rollTotals: rollTotals,
            result: result,
        };
    }
    return roll;
}
export default createRoll;
